import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, Space, Popconfirm, message, Card, Row, Col, Divider, Radio } from 'antd';
import axios from 'axios';
import { data, useNavigate } from 'react-router-dom';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts'; // ต้องนำเข้า vfs_fonts.js ที่คุณสร้างเอง
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';
import API_BASE_URL from '../../config/api';
import formB from './formB.png';
import TempleFormDrawer from './TempleFormDrawer';
import {
  HomeOutlined,
  BankOutlined,
  AppstoreOutlined,
  CheckCircleOutlined,
  TeamOutlined,
  SearchOutlined,
  FileAddOutlined,
  PrinterOutlined
} from '@ant-design/icons';


dayjs.extend(buddhistEra);
dayjs.locale('th');

//การเพิ่ม Font ใน pdf Maker
//https://pdfmake.github.io/docs/0.1/fonts/custom-fonts-client-side/vfs/

pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
}


function getCurrentYear() {
  return new Date().getFullYear(); // เช่น 2025
}


const TempleStatsCards = (data1, data2) => {

  const data = { ...data1 };

  console.log('component Data', data);

  const cardData = [
    {
      title: 'ทั้งหมด/แห่ง',
      value: data.data1.totalAll,
      icon: <HomeOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
      background: '#e6f7ff',
    },
    {
      title: 'วัด (วัดราษฎร์, พัทธสีมา, วิสุงคามสีมา)',
      value: data.data1.temples,
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#eb2f96' }} />,
      background: '#fff0f6',
    },
    {
      title: 'พระอารามหลวง',
      value: data.data1.royal,
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#eb2f96' }} />,
      background: '#fff0f6',
    },
  ];


  const cardData2 = [
    {
      title: 'วัดราษฎร์',
      value: data.data2.raj,
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#fa8c16' }} />,
      background: '#dafbc6',
    },
    {
      title: 'พัทธสีมา',
      value: data.data2.pattasima,
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#fa8c16' }} />,
      background: '#fff7e6',
    },
    {
      title: 'วิสุงคามสีมา',
      value: data.data2.wisung,
      icon: <CheckCircleOutlined style={{ fontSize: '24px', color: '#722ed1' }} />,
      background: '#f9f0ff',
    },
    {
      title: 'ที่พักสงฆ์',
      value: data.data2.monastery,
      icon: <TeamOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      background: '#f6ffed',
    },
  ];

  return (
    <Row gutter={[5, 5]}>
      {data1 && cardData && (<>
        {cardData.map((item, index) => (
          <Col xs={24} sm={24} md={18} lg={8} key={index}>
            <Card
              bordered={false}
              style={{ background: item.background }}
              bodyStyle={{ display: 'flex', alignItems: 'center', gap: '12px' }}
            >
              {item.icon}
              <div>
                <div style={{ fontSize: '14px', color: '#555' }}>{item.title}</div>
                <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{item.value}</div>
              </div>
            </Card>
          </Col>
        ))}
      </>)}

      {data && cardData2 && (
        <>
          {cardData2.map((item, index) => (
            <Col xs={24} sm={18} md={8} lg={12} key={index}>
              <Card
                bordered={false}
                style={{ background: item.background }}
                bodyStyle={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                {item.icon}
                <div>
                  <div style={{ fontSize: '14px', color: '#555' }}>{item.title}</div>
                  <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{item.value}</div>
                </div>
              </Card>
            </Col>
          ))}
        </>
      )}



    </Row>
  );
};

const TempleManagement = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [templeStatistic, setTempleStatistic] = useState(null);
  const [temples, setTemples] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const [editingTemple, setEditingTemple] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [stats, setStats] = useState(null); //สถิติวัด
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = React.useRef(null);
  const [formYear, setFormYear] = useState(2025); //ปีที่จะพิมพ์ข้อมูล ค่าเริ่มต้นคือ 2025

  const [pdfDataUrl, setPdfDataUrl] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [filters, setFilters] = useState({
    name: '',
    subdistrict: '',
    district: '',
    province: '',
    postal_code: '',
    type: '',
  });

  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    //console.log('Various parameters', pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };
  const setAgeSort = () => {
    setSortedInfo({
      order: 'descend',
      columnKey: 'name',
    });
  };


  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`ค้นหา ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            size="small"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            ค้นหา
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    setSearchedColumn('');
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    fetchTemples();
  };



  // ดึงข้อมูลวัดจาก API
  useEffect(() => {
    fetchProfile();
    fetchTemples();
    fetchTemplesState();
  }, [formYear]);

  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = { ...res.data, address: { province: res.data.province, district: res.data.district, subdistrict: res.data.subdistrict } };
      //console.log('Me:', data);
      setProfile(data);
      form.setFieldsValue(data);
    } catch (err) {
      message.error('ไม่สามารถโหลดข้อมูลโปรไฟล์');
    } finally {
      setLoading(false);
    }
  };

  //สถิติยอดรวมวัด
  const fetchTemplesState = async () => {

    setLoading(true);

    // ดึง token จาก localStorage
    const token = localStorage.getItem('token');
    axios.get(`${API_BASE_URL}/api/temple-stats`, {
      headers: {
        Authorization: `Bearer ${token}`, // ส่ง token ไปใน header
      }
    })

      .then(res => {

        console.log('สถิติวัด:', res.data);

        setStats(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching stats:', err);
        setLoading(false);
      });
  }

  //นับตามประเภท
  function countByType(items, type) {
    return items.filter(item => item.type === type).length;
  }

  //นับประเภทวัด
  function countAllTypes(items) {
   
    return {
      totalAll: items.length,
      temples: items.filter(i =>
        ['พัทธสีมา', 'วิสุงคามสีมา', 'วัดราษฎร์', 'พระอารามหลวง'].includes(i.type)
      ).length,
      royal: items.filter(i => i.type === 'พระอารามหลวง').length,
      monastery: items.filter(i => i.type === 'ที่พักสงฆ์').length,
      pattasima: items.filter(i => i.type === 'พัทธสีมา').length,
      wisung: items.filter(i => i.type === 'วิสุงคามสีมา').length,
      raj: items.filter(i => i.type === 'วัดราษฎร์').length,
    };
  }


  const filterByProvince = async (dataArray, provinceName) => {
    //return dataArray.filter(item => item.province === provinceName);

    const filtered = dataArray.filter(item => item.province === provinceName);

    // เพิ่ม index เป็นลำดับที่ 1, 2, 3, ...
    return filtered.map((item, index) => ({
      ...item,
      index: index + 1,
    }));


  }


  async function fetchTempleStatistic(templeId, year) {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/temple-statistics/${templeId}/${formYear}`);
      //console.log('statistic', res.data);
      const statisticData = {
        ...res.data,
        sendAt: res.data.sendAt ? dayjs(res.data.sendAt, 'YYYY-MM-DD') : null
      };

      setTempleStatistic(statisticData)

      return statisticData;

    } catch (error) {
      message.error('ไม่สามารถโหลดข้อมูลเก่าได้ หรือยังไม่มีสถิติของปีปัจจุบัน');
      return null;
    }
  }


  const fetchTemples = async () => {

    setLoading(true);

    // ดึง token และ user  จาก localStorage
    const token = localStorage.getItem('token');

    try {
      // ถ้ามี token ก็แนบไปใน header
      const res = await axios.get(`${API_BASE_URL}/api/get-temples`, {
        headers: {
          Authorization: `Bearer ${token}`, // ส่ง token ไปใน header
        },
      });

      const userDataRes = await axios.get(`${API_BASE_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const profileData = { ...userDataRes.data, address: { province: userDataRes.data.province, district: userDataRes.data.district, subdistrict: userDataRes.data.subdistrict } };

      //console.log('temples', res.data.temples);
      //console.log('profile:', data);
      const province = profileData.province;

      // เรียกใช้ฟังก์ชัน
      const filteredTemples = await filterByProvince(res.data.temples, province);

      if (profileData.level === 'จังหวัด') {
        setTemples(filteredTemples);
        const stats = countAllTypes(filteredTemples);
        setStats(stats);

      } else if (profileData.level == 'ภาค') {
        const filtered = res.data.temples.map((item, index) => ({
          ...item,
          index: index + 1,
        }));
        setTemples(filtered);
        const stats = countAllTypes(res.data.temples);
        setStats(stats);
      }


    } catch (error) {
      message.error('เกิดข้อผิดพลาดขณะดึงรายชื่อวัด !!!');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditData(null);
    setDrawerOpen(true);
  };

  const handleEdit = (record) => {
    setEditData(record);
    setDrawerOpen(true);
  };


  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/temples/${id}`);
      message.success('ลบข้อมูลเรียบร้อย');
      fetchTemples();
      fetchTemplesState();
    } catch {
      message.error('ไม่สามารถลบข้อมูลได้');
    }
  };



  const handleSubmit = async (data) => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));
    const { province, district, subdistrict } = data;

    data.created_by = user.id;
    data.province = province;
    data.district = district;
    data.subdistrict = subdistrict;

    //console.log('values:', data);

    if (editData) {
      await axios.put(`${API_BASE_URL}/api/temples/${editData.id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } else {
      await axios.post(`${API_BASE_URL}/api/temples`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    }
    setDrawerOpen(false);
    fetchTemples();
    fetchTemplesState();

    message.success('บันทึกข้อมูลเรียบร้อยแล้ว');

  };
  
  //แปลงเลขอาราบิค ---> เลขไทย
  function toThaiDigits(input) {
    const str = String(input); // แปลงเป็น string ก่อน
    if (!/\d/.test(str)) return str;
    return str.replace(/\d/g, d => '๐๑๒๓๔๕๖๗๘๙'[d]);
  }

  //แปลงรูปเป็น Base 64
  const toBase64 = (url) =>
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      }));

  const mm = mm => mm * 2.83465;

  function formatThaiDate(dateInput, type) {
    const date = new Date(dateInput);
    if (isNaN(date)) return ''; // ถ้า date ไม่ถูกต้อง

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // เดือน 0-11
    const year = date.getFullYear() + 543; // แปลง ค.ศ. เป็น พ.ศ.

    if (type === 'day') {
      return `${day}`;
    } else if (type === 'month') {
      return `${getThaiMonthName(month)}`;
    } else if (type === 'year') {
      return `${year}`;
    }

    function getThaiMonthName(monthInput) {
      const thaiMonths = [
        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ];

      const monthNumber = parseInt(monthInput, 10); // แปลงเป็นตัวเลข
      if (monthNumber < 1 || monthNumber > 12) return ''; // ตรวจสอบว่าเป็น 1-12

      return thaiMonths[monthNumber - 1];
    }

  }

  function mergeTemplesWithStatistics(temples, statistics) {
    return temples.map(temple => {
      const templeStats = statistics.filter(stat => stat.temple_id === temple.id);
      console.log('stat', templeStats);
      return {
        ...temple,
        ...templeStats[0], // จะได้เป็น array ของสถิติของวัดนี้
      };
    });
  }


  async function generateMultiPagePDF(dataList) {
    // ดึงปีปัจจุบันออกมา
    // const year = getCurrentYear();
    const statisticData = await axios.get(`${API_BASE_URL}/api/temple-statistics/${formYear}`)
    const temple = await mergeTemplesWithStatistics(dataList, statisticData.data)

    console.log('print datta list', temple);

    const backgroundBase64 = await toBase64(formB);

    const docDefinition = {
      version: '1.5',
      subset: 'PDF/A-3a',
      tagged: true,
      displayTitle: true,
      // a string or { width: number, height: number }
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'portrait',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [10, 10, 10, 10],
      info: {
        title: `บัญชีกลางปีวัดธรรมยุต`
      },
      background: [
        {
          image: backgroundBase64,
          width: 595.28, // A4 width in points
          absolutePosition: { x: 0, y: 0 },
        },
      ],
      content: temple.map((temple, index) => {
        const pageNo = index + 1
        return {
          stack: [
            {
              text: `หน้า ${toThaiDigits(pageNo)}`,
              absolutePosition: {
                x: mm(185), // 30 mm จากซ้าย
                y: mm(10), // 50 mm จากบน 
              },
              fontSize: 18
            },
            {
              text: `${temple.sender_name ? toThaiDigits(temple.sender_name) : '-'}`, //พระที่นำส่งข้อมูล
              absolutePosition: {
                x: mm(35), // 30 mm จากซ้าย
                y: mm(30), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.sendAt ? toThaiDigits(formatThaiDate(temple.sendAt, 'day')) : '-'}`, //วันที่ส่งข้อมูล
              absolutePosition: {
                x: mm(120), // 30 mm จากซ้าย
                y: mm(30), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.sendAt ? toThaiDigits(formatThaiDate(temple.sendAt, 'month')) : '-'}`, //เดือนที่ส่งข้อมูล
              absolutePosition: {
                x: mm(150), // 30 mm จากซ้าย
                y: mm(30), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.sendAt ? toThaiDigits(formatThaiDate(temple.sendAt, 'year')) : '-'}`, //ปีที่ส่งข้อมูล
              absolutePosition: {
                x: mm(186), // 30 mm จากซ้าย
                y: mm(30), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.name}`, //ชื่อวัด
              absolutePosition: {
                x: mm(38), // 30 mm จากซ้าย
                y: mm(38), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.moo)}`, //บ้านเลขที่ หมู่ที่
              absolutePosition: {
                x: mm(100), // 30 mm จากซ้าย
                y: mm(38), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.address}`, //บ้าน
              absolutePosition: {
                x: mm(168), // 30 mm จากซ้าย
                y: mm(38), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.subdistrict}`, //ตำบล
              absolutePosition: {
                x: mm(38), // 30 mm จากซ้าย
                y: mm(45.5), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.district}`, //อำเภอ
              absolutePosition: {
                x: mm(82), // 30 mm จากซ้าย
                y: mm(45.5), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.province}`, //จังหวัด
              absolutePosition: {
                x: mm(136), // 30 mm จากซ้าย
                y: mm(45.5), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.postal_code ? temple.postal_code : '-')}`, //รหัสไปรษณีย์
              absolutePosition: {
                x: mm(179), // 30 mm จากซ้าย
                y: mm(45.5), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.phone_number)}`, //เบอร์โทรศัพท์
              absolutePosition: {
                x: mm(92), // 30 mm จากซ้าย
                y: mm(54), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_name)}`, //นามเจ้าอาวาส
              absolutePosition: {
                x: mm(52), // 30 mm จากซ้าย
                y: mm(62), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_old_name)}`, //นามเดิม
              absolutePosition: {
                x: mm(125), // 30 mm จากซ้าย
                y: mm(62), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
              absolutePosition: {
                x: mm(184), // 30 mm จากซ้าย
                y: mm(62), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
              absolutePosition: {
                x: mm(184), // 30 mm จากซ้าย
                y: mm(62), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_age ? temple.abbot_age : '-')}`, //อายุเจ้าอาวาส
              absolutePosition: {
                x: mm(34), // 30 mm จากซ้าย
                y: mm(70), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_pansa ? temple.abbot_pansa : '-')}`, //พรรษา
              absolutePosition: {
                x: mm(61), // 30 mm จากซ้าย
                y: mm(70), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_buddhist_education ? temple.abbot_buddhist_education : '-')}`, //วิทยฐานะทางธรรม
              absolutePosition: {
                x: mm(101), // 30 mm จากซ้าย
                y: mm(70), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_education ? temple.abbot_education : '-')}`, //วุฒิทางโลก
              absolutePosition: {
                x: mm(162), // 30 mm จากซ้าย
                y: mm(70), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${toThaiDigits(temple.abbot_position ? temple.abbot_position : '-')}`, //ตำแหน่งทางการปกครองหรือพระอุปัชฌาย์
              absolutePosition: {
                x: mm(90), // 30 mm จากซ้าย
                y: mm(78.5), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_count ? toThaiDigits(temple.monks_count) : '0'}`, //จำนวนพระภิกษุ
              absolutePosition: {
                x: mm(56), // 30 mm จากซ้าย
                y: mm(86), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_count ? toThaiDigits(temple.novices_count) : '0'}`, //จำนวนสามเณร
              absolutePosition: {
                x: mm(110), // 30 mm จากซ้าย
                y: mm(86), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_count ? toThaiDigits(temple.temple_students_count) : '0'}`, //จำนวนศิษย์วัด
              absolutePosition: {
                x: mm(174), // 30 mm จากซ้าย
                y: mm(86), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_count ? toThaiDigits(temple.pariyatti_count) : '0'}`, //ภิกษุสามเณรเปรียญ(รูป)
              absolutePosition: {
                x: mm(80), // 30 mm จากซ้าย
                y: mm(94), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.pariyatti_detail ? toThaiDigits(temple.pariyatti_detail) : '-'}`, //แต่ละประโยคมีจำนวนดังนี้.-
              absolutePosition: {
                x: mm(27), // 30 mm จากซ้าย
                y: mm(102), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_naktham3_count ? toThaiDigits(temple.monks_naktham3_count) : '-'}`, //ภิกษุนักธรรมเอก
              absolutePosition: {
                x: mm(77), // 30 mm จากซ้าย
                y: mm(110), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.novices_naktham3_count ? toThaiDigits(temple.novices_naktham3_count) : '-'}`, //สามเณรนักธรรมเอก
              absolutePosition: {
                x: mm(175), // 30 mm จากซ้าย
                y: mm(110), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_patimokkha_count ? toThaiDigits(temple.monks_patimokkha_count) : '-'}`, //ภิกษุปาฏิโมกข์
              absolutePosition: {
                x: mm(77), // 30 mm จากซ้าย
                y: mm(118), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_over10_pansa_count ? toThaiDigits(temple.monks_over10_pansa_count) : '-'}`, //มีพรรษาพ้นสิบ
              absolutePosition: {
                x: mm(175), // 30 mm จากซ้าย
                y: mm(118), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monks_with_titles_count ? toThaiDigits(temple.monks_with_titles_count) : '-'}`, //ภิกษุทรงสมณศักดิ์
              absolutePosition: {
                x: mm(75), // 30 mm จากซ้าย
                y: mm(126), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.monk_titles_detail ? toThaiDigits(temple.monk_titles_detail) : '-'}`, //ภิกษุทรงสมณศักดิ์
              absolutePosition: {
                x: mm(27), // 30 mm จากซ้าย
                y: mm(134), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.land_temple_rai ? toThaiDigits(temple.land_temple_rai) : '-'}`, //ที่ดินตั้งวัด
              absolutePosition: {
                x: mm(57), // 30 mm จากซ้าย
                y: mm(142), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.land_dharma_rai ? toThaiDigits(temple.land_dharma_rai) : '-'}`, //ที่ดินของวัด (ที่ธรณีสงฆ์)
              absolutePosition: {
                x: mm(162), // 30 mm จากซ้าย
                y: mm(142), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.type ? toThaiDigits(temple.type) : '-'}`, //วัดเป็นพัทธสีมา หรือวิสุงคามสีมา
              absolutePosition: {
                x: mm(162), // 30 mm จากซ้าย
                y: mm(149), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.established_year ? toThaiDigits(temple.established_year) : '-'}`, //ตั้งวัดเมื่อ (พ.ศ.)
              absolutePosition: {
                x: mm(70), // 30 mm จากซ้าย
                y: mm(158), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.total_former_abbots ? toThaiDigits(temple.total_former_abbots) : '-'}`, //มีเจ้าอาวาสมาแล้ว (รูป)
              absolutePosition: {
                x: mm(163), // 30 mm จากซ้าย
                y: mm(158), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.preach_on_buddha_days ? toThaiDigits(temple.preach_on_buddha_days) : '-'}`, //มีการแสดงธรรมทุกวันธรรมสวนะ
              absolutePosition: {
                x: mm(103), // 30 mm จากซ้าย
                y: mm(166), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.listeners_in_rainy ? toThaiDigits(temple.listeners_in_rainy) : '-'}`, //วันหนึ่งอย่างมากในพรรษา
              absolutePosition: {
                x: mm(86), // 30 mm จากซ้าย
                y: mm(173), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.listeners_out_rainy ? toThaiDigits(temple.listeners_out_rainy) : '-'}`, //วันหนึ่งอย่างมากนอกพรรษา
              absolutePosition: {
                x: mm(170), // 30 mm จากซ้าย
                y: mm(173), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.religious_assets ? toThaiDigits(temple.religious_assets) : '-'}`, //ศาสนวัตถุสำคัญของวัด
              absolutePosition: {
                x: mm(30), // 30 mm จากซ้าย
                y: mm(188), // 50 mm จากบน 
              },
              fontSize: 18,
            },
            {
              text: `${temple.religious_structures ? toThaiDigits(temple.religious_structures) : '-'}`, //ศาสนสถานของวัด
              absolutePosition: {
                x: mm(55), // 30 mm จากซ้าย
                y: mm(197), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.has_priyatti_school ? toThaiDigits(temple.has_priyatti_school) : '-'}`, //มีโรงเรียนปริยัติธรรม
              absolutePosition: {
                x: mm(69), // 30 mm จากซ้าย
                y: mm(211), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.priyatti_students_count ? toThaiDigits(temple.priyatti_students_count) : '-'}`, //จำนวนนักเรียนปริยัติธรรม
              absolutePosition: {
                x: mm(177), // 30 mm จากซ้าย
                y: mm(211), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.meditation_training ? toThaiDigits(temple.meditation_training) : '-'}`, //มีการอบรมกรรมฐาน
              absolutePosition: {
                x: mm(68), // 30 mm จากซ้าย
                y: mm(220), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.public_benefit_activity ? toThaiDigits(temple.public_benefit_activity) : '-'}`, //มีการบำเพ็ญสาธารณสงเคราะห์
              absolutePosition: {
                x: mm(30), // 30 mm จากซ้าย
                y: mm(234), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.has_school_for_children ? toThaiDigits(temple.has_school_for_children) : '-'}`, //มีโรงเรียนสำหรับเด็กหรือฆราวาส
              absolutePosition: {
                x: mm(163), // 30 mm จากซ้าย
                y: mm(250), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `${temple.summary_monks_change ? toThaiDigits(temple.summary_monks_change) : '-'}`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
              absolutePosition: {
                x: mm(73), // 30 mm จากซ้าย
                y: mm(267), // 50 mm จากบน 
              },
              fontSize: 18,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
            {
              text: `พิมพ์จากระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธ)`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
              absolutePosition: {
                x: mm(130), // 30 mm จากซ้าย
                y: mm(287), // 50 mm จากบน 
              },
              fontSize: 13,
              lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
            },
          ],
          // เพิ่ม pageBreak เฉพาะถ้าไม่ใช่หน้าแรก
          pageBreak: index !== 0 ? 'before' : undefined,
        };
      }),
      defaultStyle: {
        font: 'THSarabunNew', // ถ้าคุณใช้ฟอนต์ไทย
        fontSize: 16
      }
    };

    pdfMake.createPdf(docDefinition).open();

  }

  async function printPDF(temple, templeStatistic) {

    if (!templeStatistic) {
      templeStatistic = {};
    }

    const backgroundBase64 = await toBase64(formB);

    var docDefinition = {
      version: '1.5',
      subset: 'PDF/A-3a',
      tagged: true,
      displayTitle: true,
      // a string or { width: number, height: number }
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'portrait',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [10, 10, 10, 10],
      info: {
        title: `${temple.name}-บัญชีกลางปีวัดธรรมยุต`
      },
      background: [
        {
          image: backgroundBase64,
          width: 595.28, // A4 width in points
          absolutePosition: { x: 0, y: 0 },
        },
      ],
      content: [
        {
          text: `${templeStatistic.sender_name ? toThaiDigits(templeStatistic.sender_name) : '-'}`, //พระที่นำส่งข้อมูล
          absolutePosition: {
            x: mm(35), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'day')) : '-'}`, //วันที่ส่งข้อมูล
          absolutePosition: {
            x: mm(120), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'month')) : '-'}`, //เดือนที่ส่งข้อมูล
          absolutePosition: {
            x: mm(150), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.sendAt ? toThaiDigits(formatThaiDate(templeStatistic.sendAt, 'year')) : '-'}`, //ปีที่ส่งข้อมูล
          absolutePosition: {
            x: mm(186), // 30 mm จากซ้าย
            y: mm(30), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${temple.name}`, //ชื่อวัด
          absolutePosition: {
            x: mm(38), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.moo)}`, //บ้านเลขที่ หมู่ที่
          absolutePosition: {
            x: mm(100), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.address}`, //บ้าน
          absolutePosition: {
            x: mm(168), // 30 mm จากซ้าย
            y: mm(38), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.subdistrict}`, //ตำบล
          absolutePosition: {
            x: mm(38), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.district}`, //อำเภอ
          absolutePosition: {
            x: mm(82), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.province}`, //จังหวัด
          absolutePosition: {
            x: mm(136), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.postal_code ? temple.postal_code : '-')}`, //รหัสไปรษณีย์
          absolutePosition: {
            x: mm(179), // 30 mm จากซ้าย
            y: mm(45.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.phone_number)}`, //เบอร์โทรศัพท์
          absolutePosition: {
            x: mm(92), // 30 mm จากซ้าย
            y: mm(54), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_name)}`, //นามเจ้าอาวาส
          absolutePosition: {
            x: mm(52), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_old_name)}`, //นามเดิม
          absolutePosition: {
            x: mm(125), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
          absolutePosition: {
            x: mm(184), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_dharma_name)}`, //ฉายาเจ้าอาวาส
          absolutePosition: {
            x: mm(184), // 30 mm จากซ้าย
            y: mm(62), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_age ? temple.abbot_age : '-')}`, //อายุเจ้าอาวาส
          absolutePosition: {
            x: mm(34), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_pansa ? temple.abbot_pansa : '-')}`, //พรรษา
          absolutePosition: {
            x: mm(61), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_buddhist_education ? temple.abbot_buddhist_education : '-')}`, //วิทยฐานะทางธรรม
          absolutePosition: {
            x: mm(101), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_education ? temple.abbot_education : '-')}`, //วุฒิทางโลก
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(70), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${toThaiDigits(temple.abbot_position ? temple.abbot_position : '-')}`, //ตำแหน่งทางการปกครองหรือพระอุปัชฌาย์
          absolutePosition: {
            x: mm(90), // 30 mm จากซ้าย
            y: mm(78.5), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.monks_count) : '0'}`, //จำนวนพระภิกษุ
          absolutePosition: {
            x: mm(56), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.novices_count) : '0'}`, //จำนวนสามเณร
          absolutePosition: {
            x: mm(110), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.temple_students_count) : '0'}`, //จำนวนศิษย์วัด
          absolutePosition: {
            x: mm(174), // 30 mm จากซ้าย
            y: mm(86), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_count ? toThaiDigits(templeStatistic.pariyatti_count) : '0'}`, //ภิกษุสามเณรเปรียญ(รูป)
          absolutePosition: {
            x: mm(80), // 30 mm จากซ้าย
            y: mm(94), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.pariyatti_detail ? toThaiDigits(templeStatistic.pariyatti_detail) : '-'}`, //แต่ละประโยคมีจำนวนดังนี้.-
          absolutePosition: {
            x: mm(27), // 30 mm จากซ้าย
            y: mm(102), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_naktham3_count ? toThaiDigits(templeStatistic.monks_naktham3_count) : '-'}`, //ภิกษุนักธรรมเอก
          absolutePosition: {
            x: mm(77), // 30 mm จากซ้าย
            y: mm(110), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.novices_naktham3_count ? toThaiDigits(templeStatistic.novices_naktham3_count) : '-'}`, //สามเณรนักธรรมเอก
          absolutePosition: {
            x: mm(175), // 30 mm จากซ้าย
            y: mm(110), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_patimokkha_count ? toThaiDigits(templeStatistic.monks_patimokkha_count) : '-'}`, //ภิกษุปาฏิโมกข์
          absolutePosition: {
            x: mm(77), // 30 mm จากซ้าย
            y: mm(118), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_over10_pansa_count ? toThaiDigits(templeStatistic.monks_over10_pansa_count) : '-'}`, //มีพรรษาพ้นสิบ
          absolutePosition: {
            x: mm(175), // 30 mm จากซ้าย
            y: mm(118), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monks_with_titles_count ? toThaiDigits(templeStatistic.monks_with_titles_count) : '-'}`, //ภิกษุทรงสมณศักดิ์
          absolutePosition: {
            x: mm(75), // 30 mm จากซ้าย
            y: mm(126), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.monk_titles_detail ? toThaiDigits(templeStatistic.monk_titles_detail) : '-'}`, //ภิกษุทรงสมณศักดิ์
          absolutePosition: {
            x: mm(27), // 30 mm จากซ้าย
            y: mm(134), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.land_temple_rai ? toThaiDigits(templeStatistic.land_temple_rai) : '-'}`, //ที่ดินตั้งวัด
          absolutePosition: {
            x: mm(57), // 30 mm จากซ้าย
            y: mm(142), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.land_dharma_rai ? toThaiDigits(templeStatistic.land_dharma_rai) : '-'}`, //ที่ดินของวัด (ที่ธรณีสงฆ์)
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(142), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.type ? toThaiDigits(temple.type) : '-'}`, //วัดเป็นพัทธสีมา หรือวิสุงคามสีมา
          absolutePosition: {
            x: mm(162), // 30 mm จากซ้าย
            y: mm(149), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${temple.established_year ? toThaiDigits(temple.established_year) : '-'}`, //ตั้งวัดเมื่อ (พ.ศ.)
          absolutePosition: {
            x: mm(70), // 30 mm จากซ้าย
            y: mm(158), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.total_former_abbots ? toThaiDigits(templeStatistic.total_former_abbots) : '-'}`, //มีเจ้าอาวาสมาแล้ว (รูป)
          absolutePosition: {
            x: mm(163), // 30 mm จากซ้าย
            y: mm(158), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.preach_on_buddha_days ? toThaiDigits(templeStatistic.preach_on_buddha_days) : '-'}`, //มีการแสดงธรรมทุกวันธรรมสวนะ
          absolutePosition: {
            x: mm(103), // 30 mm จากซ้าย
            y: mm(166), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.listeners_in_rainy ? toThaiDigits(templeStatistic.listeners_in_rainy) : '-'}`, //วันหนึ่งอย่างมากในพรรษา
          absolutePosition: {
            x: mm(86), // 30 mm จากซ้าย
            y: mm(173), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.listeners_out_rainy ? toThaiDigits(templeStatistic.listeners_out_rainy) : '-'}`, //วันหนึ่งอย่างมากนอกพรรษา
          absolutePosition: {
            x: mm(170), // 30 mm จากซ้าย
            y: mm(173), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.religious_assets ? toThaiDigits(templeStatistic.religious_assets) : '-'}`, //ศาสนวัตถุสำคัญของวัด
          absolutePosition: {
            x: mm(30), // 30 mm จากซ้าย
            y: mm(188), // 50 mm จากบน 
          },
          fontSize: 18,
        },
        {
          text: `${templeStatistic.religious_structures ? toThaiDigits(templeStatistic.religious_structures) : '-'}`, //ศาสนสถานของวัด
          absolutePosition: {
            x: mm(55), // 30 mm จากซ้าย
            y: mm(197), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.has_priyatti_school ? toThaiDigits(templeStatistic.has_priyatti_school) : '-'}`, //มีโรงเรียนปริยัติธรรม
          absolutePosition: {
            x: mm(69), // 30 mm จากซ้าย
            y: mm(211), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.priyatti_students_count ? toThaiDigits(templeStatistic.priyatti_students_count) : '-'}`, //จำนวนนักเรียนปริยัติธรรม
          absolutePosition: {
            x: mm(177), // 30 mm จากซ้าย
            y: mm(211), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.meditation_training ? toThaiDigits(templeStatistic.meditation_training) : '-'}`, //มีการอบรมกรรมฐาน
          absolutePosition: {
            x: mm(68), // 30 mm จากซ้าย
            y: mm(220), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.public_benefit_activity ? toThaiDigits(templeStatistic.public_benefit_activity) : '-'}`, //มีการบำเพ็ญสาธารณสงเคราะห์
          absolutePosition: {
            x: mm(30), // 30 mm จากซ้าย
            y: mm(234), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.has_school_for_children ? toThaiDigits(templeStatistic.has_school_for_children) : '-'}`, //มีโรงเรียนสำหรับเด็กหรือฆราวาส
          absolutePosition: {
            x: mm(163), // 30 mm จากซ้าย
            y: mm(250), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `${templeStatistic.summary_monks_change ? toThaiDigits(templeStatistic.summary_monks_change) : '-'}`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
          absolutePosition: {
            x: mm(73), // 30 mm จากซ้าย
            y: mm(267), // 50 mm จากบน 
          },
          fontSize: 18,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
        {
          text: `พิมพ์จากระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธ)`, //สรุปจำนวนพระภิกษุ-สามเณร-ศิษย์วัดฯ  เพิ่มขึ้น หรือลดลง
          absolutePosition: {
            x: mm(130), // 30 mm จากซ้าย
            y: mm(287), // 50 mm จากบน 
          },
          fontSize: 13,
          lineHeight: 0.8,       // ค่าเริ่มต้นคือ 1.2
        },
      ],
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };


    pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
      setPdfDataUrl(dataUrl);
      setIsModalVisible(true);
    });

  }

  function thaiToArabicDigits(input) {
    const str = typeof input === 'string' ? input : String(input);
    const thaiDigits = '๐๑๒๓๔๕๖๗๘๙';
    const arabicDigits = '0123456789';

    return str.replace(/[๐-๙]/g, t => arabicDigits[thaiDigits.indexOf(t)]);
  }


  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: (
        <Input
          placeholder="ชื่อวัด"
          value={filters.name}
          onChange={e => handleFilterChange(e, 'name')}
        />
      ), dataIndex: 'name', key: 'name',
    },
    { title: 'ที่อยู่', dataIndex: 'moo', key: 'moo', },
    { title: 'บ้าน', dataIndex: 'address', key: 'address', },
    {
      title: (
        <Input
          placeholder="ตำบล"
          value={filters.subdistrict}
          onChange={e => handleFilterChange(e, 'subdistrict')}
        />
      ), dataIndex: 'subdistrict', key: 'subdistrict',
    },
    {
      title: (
        <Input
          placeholder="อำเภอ"
          value={filters.district}
          onChange={e => handleFilterChange(e, 'district')}
        />
      ), dataIndex: 'district', key: 'district',
    },
    {
      title: (
        <Input
          placeholder="จังหวัด"
          value={filters.province}
          onChange={e => handleFilterChange(e, 'province')}
        />
      ), dataIndex: 'province', key: 'province',
    },
    {
      title: (
        <Input
          placeholder="รหัสไปรษณีย์"
          value={filters.postal_code}
          onChange={e => handleFilterChange(e, 'postal_code')}
        />
      ), dataIndex: 'postal_code', key: 'postal_code',
    },
    {
      title: (
        <Input
          placeholder="เบอร์โทร"
          value={filters.phone_number}
          onChange={e => handleFilterChange(e, 'phone_number')}
        />
      ), dataIndex: 'phone_number', key: 'phone_number',
      render: (text, record, index) => thaiToArabicDigits(text),
    },
    {
      title: (
        <Input
          placeholder="สถานะ"
          value={filters.type}
          onChange={e => handleFilterChange(e, 'type')}
        />
      ), dataIndex: 'type', key: 'type'
    },
    {
      title: 'การจัดการ',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={async () => {
            // ดึงปีปัจจุบันออกมา
            const year = formYear ? formYear : getCurrentYear();
            const statistic = await fetchTempleStatistic(record.id, year);
            printPDF(record, statistic)
          }}>
            พิมพ์
          </Button>
          <Button type="link" onClick={() => navigate(`/print-preview/${record.id}`)}>
            ดูรายละเอียด
          </Button>
          <Button onClick={() => handleEdit(record)}>แก้ไข</Button>
          <Popconfirm title="ยืนยันการลบ?" onConfirm={() => handleDelete(record.id)}>
            <Button danger>ลบ</Button>
          </Popconfirm>

        </Space>
      ),
    },
  ];

  const handleFilterChange = (e, field) => {
    setFilters(prev => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const filteredData = temples.filter(record =>
    Object.keys(filters).every(field =>
      filters[field] === '' || (record[field] ?? '').toLowerCase().includes(filters[field].toLowerCase())
    )
  );

  //การค้นหาแบบตัดคำแยกค้นหาและต้องมีทุกคำ
  const filteredTemples = temples.filter((temple) => {
    const keywords = searchText.toLowerCase().split(' ').filter(Boolean); // แยกคำ
    const combined = `${temple.name} ${temple.province} ${temple.postal_code}`.toLowerCase();

    // ต้องมีทุกคำใน combined
    return keywords.every((keyword) => combined.includes(keyword));
  });

  const handleChangeYear = e => {
    setFormYear(e.target.value);
  };

  return (
    <>
      <h1 style={{ marginBottom: 16 }}>จัดการข้อมูลวัด</h1>
      <div
        style={{
          position: 'absolute',
          top: 100,
          right: 16,
          zIndex: 1000,
        }}
      >
        <Space size={'large'}>
          <Divider orientation="center">เลือกปีบัญชี</Divider>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center', // จัดกลางแนวนอน
              alignItems: 'center', // จัดกลางแนวตั้ง
            }}
          >
            <Radio.Group name="year" value={formYear} onChange={handleChangeYear} >
              {Array.from(
                { length: new Date().getFullYear() - 2023 + 1 },
                (_, i) => 2023 + i
              ).map(adYear => (
                <Radio.Button key={adYear} value={String(adYear)}>
                  {adYear + 543}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>
          <Button type="primary" onClick={async () => generateMultiPagePDF(filteredData ? searchText ? filteredTemples : filteredData : temples)} style={{ marginBottom: 16, width: 250 }} size="large" icon={<PrinterOutlined />}>
            พิมพ์บัญชีกลางปี
          </Button>
          <Button type="primary" onClick={handleAdd} style={{ marginBottom: 16, width: 250 }} size="large" icon={<FileAddOutlined />}>
            เพิ่มวัด
          </Button>
        </Space>
      </div>

      <Modal
        title="แบบฟอร์มบัญชีกลางปี"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width="80%"
        style={{ top: 20 }}
      >
        {pdfDataUrl && (
          <iframe
            src={pdfDataUrl}
            title="PDF"
            width="100%"
            height="600px"
            style={{ border: 'none' }}
          />
        )}
      </Modal>

      {stats && <TempleStatsCards data1={stats} data2={stats} />}


      <div style={{ marginBottom: 16, marginTop: 10 }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Input.Search
            placeholder="ค้นหา ชื่อวัด จังหวัด รหัสไปรษณีย์"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300 }}
            allowClear
          />
        </div>
      </div>


      <Table
        columns={columns}
        dataSource={filteredData ? searchText ? filteredTemples : filteredData : temples}
        rowKey="id"
        loading={loading}
        onChange={handleChange}
        style={{ marginTop: 10 }}
        pagination={{
          // pageSize: 5, // จำนวนแถวต่อหน้า
          showSizeChanger: true, // ให้ผู้ใช้เปลี่ยนจำนวนแถวต่อหน้าได้
          pageSizeOptions: ['5', '10', '20', '50', '100'], // ตัวเลือก
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} จากทั้งหมด ${total} รายการ`,
        }}
      />

      <TempleFormDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onSubmit={handleSubmit}
        initialValues={editData}
      />

    </>
  );
};

export default TempleManagement;
